$("body")
  .children()
  .each(function () {
    $(this).html(
      $(this)
        .html()
        .replace(/&#8232;/g, " ")
    );
  });

if ($(".splide")[0]) {
  document.addEventListener("DOMContentLoaded", function () {
    new Splide("#thumbnail_slide", {
      autoHeight: true,
      height: "600px",
      pagination: false,
      perPage: 7,
      perMove: 1,
      direction: "ttb",
      classes: {
        prev: "splide__arrow--prev plp-prev",
        next: "splide__arrow--next plp-next",
      },
    }).mount();
  });
}

$("#subb, #calltoactionbutton").click(function () {
  $("html, body").animate(
    {
      scrollTop: $("#footer_b").offset().top,
    },
    2000
  );
});

if (typeof imageCredit !== "undefined") {
  var degerim = $("#credit-text").length;
  if (degerim == 1 || degerim > 1) {
    $("#credit-text").text(imageCredit);
  }
}

$("a.scrollLink").click(function (event) {
  event.preventDefault();
  $("html, body").animate(
    { scrollTop: $($(this).attr("href")).offset().top - 120 },
    500
  );
});

$(".pmc-item").hover(
  function () {
    $(this).find(".sm-all").addClass("smhover");
  },
  function () {
    $(this).find(".sm-all").removeClass("smhover");
  }
);

$(".dropdown-sub").hide();
$(".dropdown").click(function () {
  $(this).find(".dropdown-sub").toggle();
});

/*nav bar animation*/
var animationx = anime({
  targets: ".whind-navigation",
  easing: "easeOutSine",
  height: "80px",
  minHeight: "80px",
  duration: 500,
  autoplay: false,
});

let whind_navigation_controller = new ScrollMagic.Controller();
let whind_navigation_scene = new ScrollMagic.Scene({
  duration: 1000,
  offset: 100,
}).addTo(whind_navigation_controller);

whind_navigation_scene.on("progress", function (event) {
  animationx.seek(whind_navigation_scene.duration() * event.progress);
});

/*nav bar animation*/

/*ba-shape-animation*/

var ba_anim = anime({
  targets: ".ba-shape",
  easing: "easeOutSine",
  scale: [1, 0.5],
  transformOrigin: "50px 50px 0",
  translateY: "300px",
  duration: 500,
  autoplay: false,
});

let ba_controller = new ScrollMagic.Controller();
let ba_scene = new ScrollMagic.Scene({
  offset: 0,
  duration: 1000,
}).addTo(ba_controller);

ba_scene.on("progress", function (event) {
  ba_anim.seek(ba_scene.duration() * event.progress);
});

/*ba-shape-animation*/

/*ba-shape-animation*/

/*ba-shape-animation*/

/*logo animation*/

var animationy = anime({
  targets: ".logobit",
  easing: "easeOutSine",
  scale: 0.4,
  duration: 500,
  autoplay: false,
});

var animationz = anime({
  targets: ".wn-item-2",
  easing: "easeOutSine",
  bottom: "0px",
  duration: 500,
  autoplay: false,
});

var animationDG = anime({
  targets: ".wn-item-1",
  easing: "easeOutSine",
  bottom: "30px",
  duration: 500,
  autoplay: false,
});

let whind_logo_controller = new ScrollMagic.Controller();
let whind_logo_scene = new ScrollMagic.Scene({
  duration: 1000,
  offset: 100,
}).addTo(whind_logo_controller);

whind_logo_scene.on("progress", function (event) {
  animationy.seek(whind_logo_scene.duration() * event.progress);
  animationz.seek(whind_logo_scene.duration() * event.progress);
  animationDG.seek(whind_logo_scene.duration() * event.progress);
});

/*logo animation*/

/* main_page third_animation */

var thething = anime({
  targets: "#after_divider_anim",
  easing: "easeOutSine",
  top: "200px",
  duration: 1000,
  autoplay: false,
});

let third_controller = new ScrollMagic.Controller();
let third_scene = new ScrollMagic.Scene({
  triggerElement: "#after_divider_anim",
  duration: 1000,
}).addTo(third_controller);

third_scene.on("progress", function (event) {
  thething.seek(third_scene.duration() * event.progress);
});
/*main_page third_animation */

/*main_page_fifth_animation*/
var fifith = anime({
  targets: "#ad-shape2",
  easing: "easeOutSine",
  top: "200px",
  duration: 1000,
  autoplay: false,
});

let fifth_controller = new ScrollMagic.Controller();
let fifth_scene = new ScrollMagic.Scene({
  triggerElement: "#ad-shape2",
  duration: 1000,
}).addTo(fifth_controller);

fifth_scene.on("progress", function (event) {
  fifith.seek(fifth_scene.duration() * event.progress);
});
/*main_page_fifth_animation*/

/*ah shape animation*/

var ah_shape = anime({
  targets: " #ah-shape",
  easing: "easeOutSine",
  top: "300px",
  duration: 1000,
  autoplay: false,
});

let ah_controller = new ScrollMagic.Controller();
let ah_scene = new ScrollMagic.Scene({
  triggerElement: "#ah-shape",
  duration: 1000,
}).addTo(ah_controller);

ah_scene.on("progress", function (event) {
  ah_shape.seek(ah_scene.duration() * event.progress);
});
/*ah shape animation*/

var mainNavDetect = $(".notMain").length;

var mobile_menu_controller = 0;

var sizeControl;
sizeControl = $(window).width();

if (sizeControl < 616 && mainNavDetect == 0) {
  whind_navigation_scene.progress(1);
  whind_logo_scene.progress(1);
  /*whind_subandsearch_scene.progress(1);*/
  whind_logo_controller.enabled(false);
  whind_navigation_controller.enabled(false);
  /* whind_subandsearch_controller.enabled(false);*/
}

if (sizeControl > 616 && mainNavDetect == 0) {
  whind_logo_controller.enabled(true);
  whind_navigation_controller.enabled(true);
  /* whind_subandsearch_controller.enabled(true);*/
  $(".lefttag").removeClass("mobile_menu_kontroller");
  $(".righttag").removeClass("mobile_menu_kontroller");
  $(".rightal")
    .find("li")
    .eq(rightalsize - 1)
    .css("padding-bottom", "0px");
  mobile_menu_controller = 0;
}

whind_logo_controller.update(true);
whind_navigation_controller.update(true);
/*whind_subandsearch_controller.update(true);*/

if (mainNavDetect > 0) {
  whind_navigation_scene.progress(1);
  whind_logo_scene.progress(1);
  /* whind_subandsearch_scene.progress(1);*/
  whind_logo_controller.enabled(false);
  whind_navigation_controller.enabled(false);
  /*whind_subandsearch_controller.enabled(false);*/
}

var rightalsize = $(".rightal").find("li").length;

$(document).ready(function () {
  //Rakuten JS Global Vars
  $("#all_accept").on("click", function () {
    window.__rmcp2 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    //console.log(window.__rmcp2);
  });

  $(".btn-manage__save").on("click", function () {
    if ($("#input_all_cookies_type_2:checked").length) {
      window.__rmcp2 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    } else {
      window.__rmcp = [];
      window.__rmcp2 = [];
    }
    console.log(window.__rmcp2);
  });

  //end Rakuten JS Global Vars
  /*
   * Replace all SVG images with inline SVG
   */
  document.querySelectorAll("img.svg").forEach(function (img) {
    var imgID = img.id;
    var imgClass = img.className;
    var imgURL = img.src;
    var imgStyle = img.style.fill;
    // console.log(imgStyle);

    fetch(imgURL)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString(text, "text/xml");

        // Get the SVG tag, ignore the rest
        var svg = xmlDoc.getElementsByTagName("svg")[0];

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== "undefined") {
          svg.setAttribute("id", imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== "undefined") {
          svg.setAttribute("class", imgClass + " replaced-svg");
        }

        // Add replaced image's style attributes to the new SVG
        if (typeof imgClass !== "undefined") {
          svg.setAttribute("style", "fill:" + imgStyle);
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        svg.removeAttribute("xmlns:a");

        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
        if (
          !svg.getAttribute("viewBox") &&
          svg.getAttribute("height") &&
          svg.getAttribute("width")
        ) {
          svg.setAttribute(
            "viewBox",
            "0 0 " +
              svg.getAttribute("height") +
              " " +
              svg.getAttribute("width")
          );
        }

        // Replace image with new SVG
        img.parentNode.replaceChild(svg, img);
        $(svg).parent().addClass("opacity-100");
      });
  });

  $(".mob_menu").on("click", function () {
    $(".lefttag").addClass("mobile_menu_kontroller");
    $(".righttag").addClass("mobile_menu_kontroller");
    $(".rightal")
      .find("li")
      .eq(rightalsize - 1)
      .css("padding-bottom", "40px");
    $(this).addClass("hide_button");
    $(".mob_menu_close").removeClass("hide_button");
    $(".rightal").addClass("wn-item-g");
    $(".rightal").find("li").addClass("decoration");
  });

  $(".mob_menu_close").on("click", function () {
    $(".lefttag").removeClass("mobile_menu_kontroller");
    $(".righttag").removeClass("mobile_menu_kontroller");
    $(".rightal")
      .find("li")
      .eq(rightalsize - 1)
      .css("padding-bottom", "0px");
    $(this).addClass("hide_button");
    $(".mob_menu").removeClass("hide_button");
    $(".rightal").removeClass("wn-item-g");
    $(".rightal").find("li").removeClass("decoration");
  });
});

var resultValue = $(".searchbin").length;
if (resultValue > 0) {
  var moveResult = $(".numberofresult").html();
  if (moveResult != "") {
    $("#resultsearch").html(moveResult);
  }
  if ($(".numberofresult").length == 0) {
    $("#resultsearch").html("0");
  }
}

if ($(".owl-carousel")[0]) {
  $(document).ready(function () {
    $(".owl-carousel").owlCarousel({
      loop: true,
      margin: 48,
      nav: true,
      autoplay: true,
      autoplayTimeout: 8000,
      autoplayHoverPause: true,
      lazyLoad: true,
      center: false,
      autoWidth: true,
      responsive: {
        0: {
          items: 1,
        },
        375: {
          items: 1,
          center: false,
          loop: false,
          margin: 20,
        },
        600: {
          items: 3,
          center: false,
          loop: false,
          margin: 20,
        },
        1000: {
          items: 4,
          center: false,
          loop: false,
          margin: 20,
        },
        1280: {
          items: 4,
          loop: false,
          margin: 20,
        },
      },
    });
  });
}

let isProductRecommendationCarouselInitialized = false;
function initProductRecommendationCarousel() {
  let $carousel = $('.product__recommendations--carousel');
  let numberOfCarouselItems = $('.product__recommendations--carousel').find('.lg-item-card').length

  let isDesktop = window.matchMedia('(min-width: 1200px').matches;
  let shouldDesktopInitialize = numberOfCarouselItems > 4;

  let isMobile = !isDesktop;
  let shouldMobileInitialize = numberOfCarouselItems > 2;

  if ((isDesktop && shouldDesktopInitialize) || (isMobile && shouldMobileInitialize)) {
    $carousel.owlCarousel({
      loop: false,
      margin: 0,
      items: 1,
      nav: false,
      /*autoplay:true,*/
      lazyLoad: false,
      dots: true,
      center: false,
      responsive: {
        0: {
          items: 1,
        },
        375: {
          items: 2,
          loop: false,
          center: false,
          margin: 0,
        },
        600: {
          items: 3,
          loop: false,
          center: false,
          margin: 0,
        },
        1000: {
          items: 4,
          loop: false,
          center: false,
          margin: 0,
          dots: numberOfCarouselItems > 4
        },
        1280: {
          items: 4,
          loop: false,
          center: false,
          margin: 0,
          dots: numberOfCarouselItems > 4
        },
      },
    });
  } else {
    console.log('destroying carousel');
    $carousel.owlCarousel('destroy');
  }

  console.log('isDesktop', isDesktop, 'isMobile', isMobile, 'shouldDesktopInitialize', shouldDesktopInitialize, 'shouldMobileInitialize', shouldMobileInitialize, 'isProductRecommendationCarouselInitialized', isProductRecommendationCarouselInitialized, 'numberOfCarouselItems', numberOfCarouselItems);
}

if ($(".product__recommendations--carousel")) {
  initProductRecommendationCarousel();

  $(window).resize(function() {
    initProductRecommendationCarousel();
  });
}


if ($(".pdm_content")[0]) {
  var owl = $(".pdm_content");
  owl.owlCarousel({
    loop: true,
    margin: 26,
    nav: false,
    /*autoplay:true,*/
    lazyLoad: true,
    dots: true,
    center: true,
    responsive: {
      0: {
        items: 1,
      },
      375: {
        items: 1,
        loop: true,
        center: false,
        margin: 0,
      },
      600: {
        items: 3,
        loop: true,
        center: true,
        margin: 26,
      },
      1000: {
        items: 4,
        loop: true,
        center: true,
        margin: 26,
      },
      1280: {
        items: 4,
        loop: true,
        center: true,
        margin: 26,
      },
    },
  });

  if ($(".dm-slider-container")[0]) {
    var owl4 = $(".dm-slider-container");
    owl4.owlCarousel({
      loop: true,
      margin: 26,
      nav: false,
      lazyLoad: true,
      /*autoplay:true,*/
      dots: true,
      center: true,
      autoWidth: true,
      responsive: {
        0: {
          items: 1,
        },
        375: {
          items: 1,
          loop: true,
          center: false,
          margin: 12,
        },
        600: {
          items: 3,
          loop: true,
          center: true,
          margin: 26,
        },
        1000: {
          items: 4,
          loop: true,
          center: true,
          margin: 26,
        },
        1280: {
          items: 4,
          loop: true,
          center: true,
          margin: 26,
        },
      },
    });
  }

  // Listen to owl events:
  owl.on("translated.owl.carousel", function (event) {
    if (
      $(".owl-item.active").find(".video-item").length > 0 &&
      $(".owl-item.active").find(".mobile_slider_item").attr("data-type") ==
        "video"
    ) {
      var vid = $(".resource").find("video").get(0);
      vid.currentTime = 0;
      $(".resource").find("video").get(0).play();
      $(".video_click").hide();
      $(".resource").show();
    } else {
      /*var video = $('.resource').find('video').get(0);*/
      /*video.pause();*/
      /*video.currentTime = 0;*/
    }
  });
}

var cli_slider = 0;
var cli_slider2 = 0;
$("#collapse_comments").click(function () {
  if (cli_slider == 0) {
    $(".comment").slideUp();
    $(this).addClass("rotatme");
    cli_slider = 1;
  } else {
    $(".comment").slideDown();
    $(this).removeClass("rotatme");
    cli_slider = 0;
  }
});

$("#collapse_comments2").click(function () {
  if (cli_slider2 == 0) {
    $(".new-comment").slideUp();
    $(this).addClass("rotatme");
    cli_slider2 = 1;
  } else {
    $(".new-comment").slideDown();
    $(this).removeClass("rotatme");
    cli_slider2 = 0;
  }
});

$("#AddressNewForm").slideUp();
var addNewAddress = 0;
$(".btn-address").click(function () {
  if (addNewAddress == 0) {
    $("#AddressNewForm").slideDown();
    addNewAddress = 1;
  } else {
    $("#AddressNewForm").slideUp();
    addNewAddress = 0;
  }
});

$(".cancel-new").click(function () {
  $("#AddressNewForm").slideUp();
  addNewAddress = 0;
});

$(".srcx").click(function () {
  $.fancybox.open({
    src: "#searchbox",
    type: "inline",
    touch: false,
    opts: {
      afterShow: function (instance, current) {
        anime({
          targets: "#searchbox",
          duration: 500,
          translateY: [-200, 200],
          easing: "easeOutSine",
        });
        $(".close_icon_container").show();
      },
      afterClose: function (instance, current) {
        $(".close_icon_container").hide();
        anime({
          targets: "#searchbox",
          duration: 0,
          translateY: [200, -200],
          easing: "easeOutSine",
        });
      },
    },
  });
});

$(".close_icon_container").click(function () {
  $.fancybox.close();
  $(this).hide();
});

/*remove parameter*/

$('body').on('click', '.btn-add', function() {
  $(".lightboxbg").show();
    $(".cart_container").show();
    anime({
      targets: ".cart_container",
      duration: 500,
      translateX: -400,
      easing: "easeOutSine",
    });

    //get their product url
    var productURL = $(this).data("url");

    //get the JSON for the product
    jQuery.getJSON(productURL + ".js", function (product) {
      var product_id = product.variants[0].id;
      CartJS.addItem(product_id);
      freeShippingCalculator();
    });
});

$(".qtybox .btnqty").on("click", function () {
  var qty = parseInt($(this).parent(".qtybox").find(".quantity-input").val());
  if ($(this).hasClass("qtyplus")) {
    var maxItemSize = $("#quantity").attr("max");
    if (maxItemSize != qty) {
      qty++;
    } else {
      qty = maxItemSize;
    }
  } else {
    if (qty > 1) {
      qty--;
    }
  }
  qty = isNaN(qty) ? 1 : qty;
  $(this).parent(".qtybox").find(".quantity-input").val(qty);
});

$(".lightboxbg").click(function () {
  anime({
    targets: ".cart_container",
    duration: 500,
    translateX: 400,
    easing: "easeOutSine",
    complete: function (anim) {
      $(".cart_container").hide();
    },
  });
  $(this).hide();
});

$("#closecart").click(function () {
  $(".lightboxbg").hide();

  anime({
    targets: ".cart_container",
    duration: 500,
    translateX: 400,
    easing: "easeOutSine",
    complete: function (anim) {
      $(".cart_container").hide();
    },
  });
});

function showCartFlyout() {
  $(".lightboxbg").show();
  $(".cart_container").show();
  anime({
    targets: ".cart_container",
    duration: 500,
    translateX: -400,
    easing: "easeOutSine",
  });
}

$(".eCom-basket").click(function () {
  showCartFlyout();
});

/*
  We don't want the user seeing the cart page. Liquid will redirect
  users from /cart to /#cart
  In that case, we want to show the flyout cart (like if the user 
  clicked the "Cart" link in checkout, got an abandoned checkout or
  manually went to /cart)
*/
if (window.location.hash && window.location.hash === "#cart") {
  showCartFlyout();
}

$("#AddToCart").click(function () {
  var product_quantity = $("#quantity").val();
  var product_variant_id = $("#getvID").val();
  CartJS.addItem(
    product_variant_id,
    product_quantity,
    {},
    {
      // Define a success callback to display a success message.
      success: function (data, textStatus, jqXHR) {
        $(".lightboxbg").show();
        $(".cart_container").show();
        anime({
          targets: ".cart_container",
          duration: 500,
          translateX: -400,
          easing: "easeOutSine",
        });
      },

      // Define an error callback to display an error message.
      error: function (jqXHR, textStatus, errorThrown) {
        $("#message").addClass("message-error");
        $("#message").html("There was a problem adding to the cart!");
        anime({
          targets: "#message",
          duration: 500,
          scaleY: [0, 1],
          easing: "easeOutSine",
        });
      },
    }
  );
});

$(".pll_menu_item").click(function () {
  $(".pll_menu_item").removeClass("active");
  $(this).addClass("active");
  var getAttr = $(this).attr("data-flag");
  $(".pll_desc_item").removeClass("active");
  $("#" + getAttr).addClass("active");
});

$(".item_adc").click(function () {
  $(".item_adc").removeClass("active");
  $(this).addClass("active");
  var getAttr = $(this).attr("data-section");
  $(".item_item_account").removeClass("active");
  $("#" + getAttr).addClass("active");
});

if ($(".thumbnail_item")[0]) {
  $(".thumbnail_item").eq(0).addClass("active");
}

$(".thumbnail_item").click(function () {
  var media_type = $(this).attr("data-type");
  var indexItem = $(this).index();
  if (indexItem != 0) {
    $(".new_badge_pdp").hide();
    $(".best_seller_pdp").hide();
  } else {
    $(".new_badge_pdp").show();
    $(".best_seller_pdp").show();
  }
  if (media_type == "image") {
    var getIMG = $(this).find("a").attr("data-rgimage");
    var getIMGzoom = $(this).find("a").attr("data-lgimage");
    $("#ProductPhotoImg").attr("data-zoom", getIMGzoom);
    $(".showcase_container")
      .find(".contain-zoom")
      .find("img")
      .eq(1)
      .attr("src", getIMGzoom);
    $("#ProductPhotoImg").attr("src", getIMG);
    $(".showcase_container").find("video").remove();
    $("#ProductPhotoImg").css("display", "inherit");
    $(".thumbnail_item").removeClass("active");
    $(".contain-zoom").show();
    $(this).addClass("active");
  }
  if (media_type == "video") {
    $(".showcase_container").find("video").remove();
    var getVIDEO = $(this).find(".resource").html();
    $("#ProductPhotoImg").css("display", "none");
    $(".showcase_container").append(getVIDEO);
    $(".thumbnail_item").removeClass("active");
    $(this).addClass("active");
    $(".contain-zoom").hide();
  }
});

$(document).ready(function () {
  if ($(".image-zoom")[0]) {
    $(".image-zoom")
      .wrap(
        '<span style="display: flex; align-items: center; justify-content: center;" class="contain-zoom"></span>'
      )
      .parent()
      .zoom({
        url: $(".image-zoom").attr("data-zoom"),
        touch: true,
      });
  }
});

$(".mps-nav-item")
  .find("a")
  .click(function () {
    var getAttr = $(this).attr("data-pl");
    $(".mps-item-text").removeClass("active");
    $("#" + getAttr).addClass("active");
    $(".mps-nav-item").find("a").removeClass("active");
    $(this).addClass("active");
  });

var playerControl = 0;
$(".product_play_button").click(function () {
  $(this).attr("data-click", 1);
  $("#product_video")[0].play();
  $(this).remove();
});

$(".pdc-img-container").hover(
  function () {
    if (playerControl != 0) $(".product_play_button").find("img").show();
  },
  function () {
    if (playerControl != 0) $(".product_play_button").find("img").hide();
  }
);

var faqSlide = 0;

$(".faqs_heading").click(function () {
  $(".faq_ul").slideUp();
  $(this).parent().find(".faq_ul").slideDown();
  $(".faq_arrow").removeClass("rotatme");
  $(this).find(".faq_arrow").addClass("rotatme");
});

var getSearchActualHeight = $(".search_container_ecom").outerHeight();
$(".search_container_ecom").css("top", getSearchActualHeight * -1);

$(".eCom-search").click(function () {
  $(".search_container_ecom").show();
  anime({
    targets: ".search_container_ecom",
    translateY: getSearchActualHeight,
    duration: 500,
    easing: "easeOutSine",
  });
  $(".search_lightbox_BG").show();
});

$(".scecom_close").click(function () {
  anime({
    targets: ".search_container_ecom",
    translateY: getSearchActualHeight * -1,
    duration: 500,
    easing: "easeOutSine",
  });
  $(".search_lightbox_BG").hide();
});

$(".search_lightbox_BG").click(function () {
  anime({
    targets: ".search_container_ecom",
    translateY: getSearchActualHeight * -1,
    duration: 500,
    easing: "easeOutSine",
    complete: function (anim) {
      $(".search_container_ecom").hide();
    },
  });
  $(this).hide();
});

$(".esr_tab_item").click(function () {
  $(".esr_tab_item").removeClass("active");
  $(this).addClass("active");
  var getData = $(this).attr("data-hideshow");
  $(".esr_search_result_container").removeClass("actives");
  $("#" + getData).addClass("actives");
});

var menu_control = 0;
$(".ihsm").click(function () {
  if (menu_control == 0) {
    $(this).find(".sub_menu_ecom_wrapper").slideDown("fast");
    menu_control = 1;
  } else {
    $(this).find(".sub_menu_ecom_wrapper").slideUp("fast");
    menu_control = 0;
  }
});

var slideControl = 0;

$("#mobiledip").click(function () {
  if (slideControl == 0) {
    $(".mobileNav-ecom-BR").slideDown();
    $(this).html(
      '<img width="18" src="https://cdn.shopify.com/s/files/1/0537/2402/0917/files/close.svg?v=1613564488"/>'
    );
    slideControl = 1;
  } else {
    $(".mobileNav-ecom-BR").slideUp();
    $(this).html(
      '<img width="23" src="https://cdn.shopify.com/s/files/1/0537/2402/0917/files/menu.svg?v=1613564207"/>'
    );
    slideControl = 0;
  }
});

var subAction = 0;

$(".sub_action").click(function () {
  if (subAction == 0) {
    $(this).parent().find(".sub-item-item").slideDown();
    subAction = 1;
  } else {
    $(this).parent().find(".sub-item-item").slideUp();
    subAction = 0;
  }
});

var emailGet = {
  email: "",
  birthday: "",
  phone: "",
};

rivets.bind($("#klaviyom"), { emailGet: emailGet });

$(".hovertrue").mouseenter(function () {
  var length_img = $(this).find("img").length;
  if (length_img > 1) $(this).find("img").eq(0).fadeOut(200);
});

$(".hovertrue").mouseleave(function () {
  var length_img = $(this).find("img").length;
  if (length_img > 1) $(this).find("img").eq(0).fadeIn(200);
});

var showPass = false;
$(".show_pass").click(function () {
  if (showPass == false) {
    $("#customerPassword").attr("type", "text");
    showPass = true;
  } else {
    $("#customerPassword").attr("type", "password");
    showPass = false;
  }
});

var showPass2 = false;
$(".show_pass2").click(function () {
  if (showPass2 == false) {
    $("#customerPassword2").attr("type", "text");
    showPass2 = true;
  } else {
    $("#customerPassword2").attr("type", "password");
    showPass2 = false;
  }
});

$(document).ready(function () {
  if ($("#accounttable")[0]) {
    $("#accounttable").basictable({
      breakpoint: 1025,
    });
  }
  if ($("#cart_table")[0]) {
    $("#cart_table").basictable({
      containerBreakpoint: 485,
    });
  }
});

$("#KlaviyoForm").submit(function (event) {
  try {
    var email = jQuery("#k_id_email").val();
    var expressionReguliere =
      /^(([^<>()[]\.,;:s@]+(.[^<>()[]\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/;
    if (expressionReguliere.test(email)) {
    } else {
      console.log("Error mail");
    }

    event.preventDefault();
    register(email);
  } catch (error) {}
});

function validateEmail(emailt) {
  var re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(emailt);
}

if ($("#register_phone_number")[0]) {
  var inputphone = document.querySelector("#register_phone_number");
  var realphonenumber;
  var detecterrorphone;
  var iti = window.intlTelInput(inputphone, {
    nationalMode: true,
    utilsScript:
      "https://cdn.shopify.com/s/files/1/0537/2402/0917/files/utils.js?v=1613996228",
  });

  var handleChange = function () {
    if (iti.isValidNumber()) {
      realphonenumber = iti.getNumber();
      detecterrorphone = true;
      $("#customer_sms").val(iti.getNumber());
    } else {
      detecterrorphone = false;
      $("#customer_sms").val("");
    }
    /*var text = (iti.isValidNumber()) ? "International: " + iti.getNumber() : "Please enter a number below";*/
    /*console.log(text);*/
  };

  inputphone.addEventListener("change", handleChange);
  inputphone.addEventListener("keyup", handleChange);
}

/*var extension = iti.getExtension();
      $('#customer_sms').val(extension);*/

function loginValidation() {
  var logEmail = $("#customerEmail").val();
  var logPass = $("#customerPassword").val();
  if (!validateEmail(logEmail)) {
    $("#message").addClass("message-error");
    $("#message").html(
      '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <span style="margin-left:15px;">Please enter a valid email address.</span>'
    );
    anime({
      targets: "#message",
      duration: 500,
      scaleY: [0, 1],
      easing: "easeOutSine",
    });
    return false;
  }

  if (logPass == null || logPass == "") {
    $("#message").addClass("message-error");
    $("#message").html(
      '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <span style="margin-left:15px;">Password section is required!</span>'
    );
    anime({
      targets: "#message",
      duration: 500,
      scaleY: [0, 1],
      easing: "easeOutSine",
    });
    return false;
  }
}

function recoverValidation() {
  var recEmail = $("#RecoverEmail").val();
  if (!validateEmail(recEmail)) {
    $("#message").addClass("message-error");
    $("#message").html(
      '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <span style="margin-left:15px;">Please enter a valid email address.</span>'
    );
    anime({
      targets: "#message",
      duration: 500,
      scaleY: [0, 1],
      easing: "easeOutSine",
    });
    return false;
  }
}

function actValidate() {
  var actPass1 = $("#customerPassword").val();
  var actPass2 = $("#customerPassword2").val();
  if (actPass1 == null || actPass1 == "") {
    $("#message").addClass("message-error");
    $("#message").html(
      '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <span style="margin-left:15px;">Password sections are required.</span>'
    );
    anime({
      targets: "#message",
      duration: 500,
      scaleY: [0, 1],
      easing: "easeOutSine",
    });
    return false;
  }

  if (actPass2 == null || actPass2 == "") {
    $("#message").addClass("message-error");
    $("#message").html(
      '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <span style="margin-left:15px;">Password sections are required.</span>'
    );
    anime({
      targets: "#message",
      duration: 500,
      scaleY: [0, 1],
      easing: "easeOutSine",
    });
    return false;
  }

  if (actPass1 != actPass2) {
    $("#message").addClass("message-error");
    $("#message").html(
      "<i class='fa fa-exclamation-triangle' aria-hidden='true'></i> <span style='margin-left:15px;'>Two passwords don't match. Please try again.</span>"
    );
    anime({
      targets: "#message",
      duration: 500,
      scaleY: [0, 1],
      easing: "easeOutSine",
    });
    return false;
  }
}

$("#AddressPhoneNew").on("keydown", function (event) {
  if (event.shiftKey) return false;
  var keyCode = event.which;
  if (
    !(
      (keyCode > 47 && keyCode < 58) ||
      (keyCode > 95 && keyCode < 106) ||
      keyCode == 08
    )
  ) {
    event.preventDefault();
  }
});

$(".phoneCalculate").on("keydown", function (event) {
  if (event.shiftKey) return false;
  var keyCode = event.which;
  if (
    !(
      (keyCode > 47 && keyCode < 58) ||
      (keyCode > 95 && keyCode < 106) ||
      keyCode == 08
    )
  ) {
    event.preventDefault();
  }
});

function newadressValidation() {
  var afnn = $("#AddressFirstNameNew").val();
  if (afnn == null || afnn == "") {
    $("#message").addClass("message-error");
    $("#message").html(
      '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <span style="margin-left:15px;">Please enter first name.</span>'
    );
    anime({
      targets: "#message",
      duration: 500,
      scaleY: [0, 1],
      easing: "easeOutSine",
    });
    return false;
  }
  var alnn = $("#AddressLastNameNew").val();
  if (alnn == null || alnn == "") {
    $("#message").addClass("message-error");
    $("#message").html(
      '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <span style="margin-left:15px;">Please enter last name.</span>'
    );
    anime({
      targets: "#message",
      duration: 500,
      scaleY: [0, 1],
      easing: "easeOutSine",
    });
    return false;
  }

  var aan = $("#AddressAddress1New").val();
  if (aan == null || aan == "") {
    $("#message").addClass("message-error");
    $("#message").html(
      '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <span style="margin-left:15px;">Please enter address.</span>'
    );
    anime({
      targets: "#message",
      duration: 500,
      scaleY: [0, 1],
      easing: "easeOutSine",
    });
    return false;
  }

  var acn = $("#AddressCountryNew").val();
  if (acn == null || acn == "---" || acn == "") {
    $("#message").addClass("message-error");
    $("#message").html(
      '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <span style="margin-left:15px;">Please enter country.</span>'
    );
    anime({
      targets: "#message",
      duration: 500,
      scaleY: [0, 1],
      easing: "easeOutSine",
    });
    return false;
  }

  var azn = $("#AddressZipNew").val();
  if (azn == null || azn == "") {
    $("#message").addClass("message-error");
    $("#message").html(
      '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> <span style="margin-left:15px;">Please enter zip code.</span>'
    );
    anime({
      targets: "#message",
      duration: 500,
      scaleY: [0, 1],
      easing: "easeOutSine",
    });
    return false;
  }
}

/*
$('#countryID').on('click', function() {
  $.fancybox.open( $('#country-lightbox'), {
    touch: false
  });
});


$('#pdpCountryLightBox').on('click', function() {
  $.fancybox.open( $('#country-lightbox'), {
    touch: false
  });
});
*/

$("#recoverRegister").click(function () {
  $("#recoveryRegister").show();
  $("#loginRegister").hide();
});

$("#cancel_register").click(function () {
  $("#recoveryRegister").hide();
  $("#loginRegister").show();
});

var expandControl = 0;

$(".expandbutton").click(function () {
  if (expandControl == 0) {
    $(this).parent().find(".expandit").slideDown();
    expandControl = 1;
  } else {
    $(this).parent().find(".expandit").slideUp();
    expandControl = 0;
  }
});

anime({
  targets: "#loading",
  rotate: "360deg",
  loop: true,
  easing: "linear",
});

//Cookies.set('newsticker', 'true');
//console.log(Cookies.get('newsticker'));
$(".ticker_close_button").click(function () {
  Cookies.set("newsticker", "false", { expires: 1 });
  $(".news_ticker").hide();
  $(".product_container").removeClass("tickerheight");
  $(".eCom-nav-container").removeClass("tickercontrol");
  $(".mobileNav-ecom-BR").css("top", "90px");
  $(".mph-content").css("margin-top", "20px");
});

if (Cookies.get("newsticker") == "false") {
  $(".news_ticker").hide();
  $(".product_container").removeClass("tickerheight");
  $(".eCom-nav-container").removeClass("tickercontrol");
  $(".mobileNav-ecom-BR").css("top", "90px");
  $(".mph-content").css("margin-top", "20px");
} else {
  $(".news_rticker").show();
  $(".eCom-nav-container").addClass("tickercontrol");
  $(".mobileNav-ecom-BR").css("top", "128px");
  $(".mph-content").css("margin-top", "31px");
  var itemnumber = $(".nt_item").length;
  var anim_kontrol = 1;
  var degerbot = -38;

  var newstickerFunction;
  
  function initNewsticker() {
    $(".carousel_container").animate({
      top: "" + degerbot * anim_kontrol + "px",
    });
    if (anim_kontrol >= itemnumber - 1) {
      anim_kontrol = 0;
      clearInterval(newstickerFunction);
      newstickerFunction = setInterval(initNewsticker, 10000);
    } else {
      anim_kontrol++;
    }
  }
  
  newstickerFunction = setInterval(initNewsticker, 10000);

  $(".nt_item").mouseenter(function () {
    clearInterval(newstickerFunction);
  });

  $(".nt_item").mouseleave(function () {
    clearInterval(newstickerFunction);
    newstickerFunction = setInterval(initNewsticker, 10000);
  });
}

$(".node_item_header_content").click(function () {
  if ($(this).parent().find(".node_item_text").hasClass("opened")) {
    $(this).parent().find(".node_item_text").slideUp();
    $(this).parent().find(".node_item_text").removeClass("opened");
    $(this).parent().find(".node_item_header_content").removeClass("flip");
  } else {
    $(this).parent().find(".node_item_text").slideDown();
    $(this).parent().find(".node_item_text").addClass("opened");
    $(this).parent().find(".node_item_header_content").addClass("flip");
  }
});

$("#gocountry").click(function () {
  window.location.href = newURL;
});

$("#burgerMenu").click(function () {
  anime({
    targets: ".slidemenu-container",
    duration: 500,
    translateX: 375,
    easing: "easeOutSine",
  });
});

$("#burgerMenuMobile").click(function () {
  anime({
    targets: ".slidemenu-container",
    duration: 500,
    translateX: 375,
    easing: "easeOutSine",
  });
});

$("#closeslide").click(function () {
  anime({
    targets: ".slidemenu-container",
    duration: 500,
    translateX: 0,
    easing: "easeOutSine",
  });
});

function alpIndexFunc(whichAlp) {
  var indexItem = $(".inindex-list").find("ul").find("li").length;
  var i;
  for (i = 0; i < indexItem; i++) {
    var dataGetValue = $(".inindex-list")
      .find("ul")
      .find("li")
      .eq(i)
      .attr("data-alp");
    if (dataGetValue == whichAlp) {
      $(".inindex-list").find("ul").find("li").eq(i).show();
      var naDetect = $(".inindex-list").find("ul").find("li").eq(i).html();
      if (naDetect == "N/A") {
        $(".inindex-list").find("ul").find("li").eq(i).html("");
      }
    }
  }
}

alpIndexFunc("A");

$(".alpindex").click(function () {
  var getAlp = $(this).html();
  $(".inindex-number").html(getAlp);
  $(".inindex-list").find("ul").find("li").hide();
  $(".alpindex").removeClass("active");
  $(this).addClass("active");
  alpIndexFunc(getAlp);
});

// to get around Chrome bug that blurs images when downscaling, images must be exact dimensions of screen,
// or equally divisible by a whole number (like using an 818px image on a 414px wide screen)
// https://bugs.chromium.org/p/chromium/issues/detail?id=562162
$(function() {
  if (window.matchMedia('(max-width: 1025px)').matches) {

    // PDP images
    $(window).on('mobilePDPImageFancyboxReadyForInitialization', function() {
      $('[data-fancybox="images"]').fancybox({});
    });

    let imageWidth = $(window).width() * 2;
  
    // NOTE: 414x is hardcoded in the liquid at main-page-hero-full, if that changes, this needs to be updated below.
    $('[data-image-window-size]').each(function() {
      let newSrc = $(this).attr('src').replace('414x', `${imageWidth}x`);
      $(this).attr('src', newSrc);
      $(this).closest('a[data-rgimage]').attr('data-rgimage', newSrc);
      $(this).closest('a[data-lgimage]').attr('data-lgimage', newSrc);
      $(this).closest('[href]').attr('href', newSrc);
    });
    $(window).trigger('mobilePDPImageFancyboxReadyForInitialization');

    // homepage banners
    // NOTE: 480x is hardcoded in the liquid at main-page-hero-full, if that changes, this needs to be updated below.
    $('.mpf-image-container picture img').each(function() {
      let newSrc = $(this).attr('src').replace('480x', `${imageWidth}x`);
      $(this).attr('src', newSrc);
    });
  }
});